<template>
  <div class="contract-page">
    <div class="clear">
      <h2 class="paging-title">合同管理</h2>
    </div>
    <ul class="tab-hd">
      <li 
        v-for="(item,index) in tabs" 
        :key="index" 
        :class="{'on':listType==item.id}"
        @click="tabClick(item.id)"
      >{{item.text}} <span class="badge" v-if="item.badge">{{item.badge}}</span></li>
    </ul>
    <!-- 已签约 -->
    <table class="table" v-show="listType==1">
      <tr>
        <th>合同编号</th>
        <th>合同名称</th>
        <th>开始时间</th>
        <th>结束时间</th>
        <th>状态</th>
        <th>操作</th>
      </tr>
      <tr v-for="(item,index) in tableData" :key="index">
        <td>{{item.ContractNum}}</td>
        <td>{{item.ContractName}}</td>
        <td class="time">{{item.StartTime}}</td>
        <td class="time">{{item.EndTime}}</td>
        <td>{{item.ContractStatusName}}</td>
        <td>
          <span class="btn-text" @click="toDetail(item)">查看</span>
        </td>
      </tr>
      <tr v-if="tableData.length==0">
        <td class="no-data" colspan="7">暂无数据</td>
      </tr>
    </table>
    <!-- 待签约 -->
    <table class="table" v-show="listType==0">
      <tr>
        <th>合同编号</th>
        <th>合同名称</th>
        <th>开始时间</th>
        <th>结束时间</th>
        <th>操作</th>
      </tr>
      <tr v-for="(item,index) in tableData" :key="index">
        <td>{{item.ContractNum}}</td>
        <td>{{item.ContractName}}</td>
        <td class="time">{{item.StartTime}}</td>
        <td class="time">{{item.EndTime}}</td>
        <td>
          <span class="btn-text" @click="toDetail(item)">去签约</span>
        </td>
      </tr>
      <tr v-if="tableData.length==0">
        <td class="no-data" colspan="7">暂无数据</td>
      </tr>
    </table>
    <el-pagination
      background
      layout="prev, pager, next"
      :current-page="pageIndex"
      :page-size="pageSize"
      :total="total"
      @current-change="pageChange">
    </el-pagination>
  </div>
</template>
<script>
import {GetUserContractList,ConvertPDF} from '@/scripts/api.js'
import {mapState} from 'vuex'
import {isDev} from '@/scripts/util.js'
export default {
  data(){
    return{
      tabs:[{
        text:'已签合同',
        id:1,
        badge:0,
      },{
        text:'待签合同',
        id:0,
        badge:0,
      }],
      listType:1,
      pageSize:10,
      pageIndex:1,
      total:0,
      tableData:[],
      loading:false,
    }
  },
  computed:{
    companyId(){
      if(this.$store.state.userInfo){
        return this.$store.state.userInfo.LoginAccountId;
      }
      return '';
    },
  },
  watch:{
    companyId(value,old){
      if(value && value!=old){
        this.loadData();
      }
    },
  },
  mounted(){
    var name=this.$route.query.name;
    if(name){
      this.form.CompanyName=name;
    }
    if(this.companyId){
      this.loadData();
    }
  },
  methods:{
    tabClick(id){
      this.listType=id;
      this.pageIndex=1;
      this.loadData();
    },
    loadData(){
      if(this.loading)return;
      this.loading=true;
      let params={
          signingProgress:this.listType,
          platform:'pcweb',
          pageNum:this.pageIndex,
          pageSize:this.pageSize,
          loginCompanyId:this.companyId,
        };
      GetUserContractList(params).then(r=>{
        this.loading=false;
        if(r.Result==1){
          this.tableData=r.Data.UserContractList || [];
          this.total=r.Data.TotalCount;
          this.tabs[1].badge=r.Data.WaitSignCount;
        }else{
          this.$toast(r.Message);
        }
      })
    },
    pageChange(data){
      this.pageIndex=data;
      this.loadData();
    },
    toDetail(item){
      if(!item.ContractFileUrl){
        this.$toast('没有合同文件！');
        return;
      }
      let _path=item.ContractFileUrl.replace('http://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/', '');
      _path=_path.replace('http://oss.insupai.com/','')
      ConvertPDF({
        filePath:_path,
        platform:'pcweb'
      }).then(r=>{
        if(r.Result==1){
          var path=encodeURIComponent(r.Data);
          var url=`${isDev?'':'/BpoJob'}/contract.html?path=${path}&contractTemplateId=${item.ContractTemplateId}&type=${this.listType==1?1:2}&contractId=${item.Id}`;
          window.location.href=url;
        }else{
          this.$toast(r.Message);
        }
      })
    },
  }
}
</script>
<style lang="scss">
.contract-page{
  .tab-hd{
    margin-top: 30px;
    background-color: #fff;
    // overflow:hidden;
    height: 40px;
    border-bottom: 1px solid #e5e5e5;
    li{
      width: 140px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 16px;
      color: #333;
      cursor: pointer;
      float: left;
      &:before{
        content: "";
        position: absolute;
        left: 50%;
        top: -1px;
        width:0;
        transform:translate(-50%);
        transition:all 0.3s linear;
        height: 2px;
        background-color: #f75959;
      }
      &.on{
        position: relative;
        color: #f75959;
        border: 1px solid #e5e5e5;
        border-bottom-color: #fff;
        z-index: 3;
        // background-color: #f8f8f8;
        &:before{
          width:100%;
        }
      }
    }
    .badge{
      display: inline-block;
      vertical-align: super;
      font-size: 12px;
      color: #fff;
      height: 16px;
      line-height: 16px;
      min-width: 16px;
      text-align: center;
      padding: 0 4px;
      border-radius: 20px;
      background-color: #f75959;
    }
  }
  .table{
    margin-top: 30px;
    border-collapse: collapse;
    border: 1px solid #e5e5e5;
    width: 100%;
    tr{
      border: 1px solid #e5e5e5;
    }
    th{
      height: 48px;
      line-height: 48px;
      background-color: #f8f8f8;
      font-size:14px;
      color:#333;
      text-align: center;
      min-width: 80px;
      font-weight: normal;
      &:nth-child(2){
        text-align: left;
      }
    }
    td{
      padding: 5px 0;
      line-height: 24px;
      font-size:14px;
      color:#333;
      text-align: center;
      &:nth-child(2){
        text-align: left;
      }
    }
    .time{
      word-break: break-all;
    }
    .btn-text{
      color: #f75959;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .el-pagination{
    text-align: right;
    margin-top: 30px;
  }
}

</style>